// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3USgJ","logo":"header_logo__mmOY3","close":"header_close__1uXQo"};